// ─── Sticker Library ─────────────────────────────────────────────────────────

export type StickerItem = {
  id: string;
  type: "svg" | "emoji" | "gif" | "sticky";
  content: string;
  label: string;
  defaultScale?: string;
};

// ─── SVG Stickers — decorative illustrated ────────────────────────────────────

export const SVG_STICKERS: StickerItem[] = [
  {
    id: "star-burst",
    type: "svg",
    label: "Star burst",
    defaultScale: "1",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40 8 L43 28 L60 18 L48 34 L68 36 L50 44 L62 60 L44 52 L42 72 L36 54 L18 64 L28 48 L8 46 L26 38 L14 22 L32 30 Z" fill="#FDE68A" stroke="#D97706" stroke-width="2" stroke-linejoin="round"/>
<circle cx="40" cy="40" r="8" fill="#FCD34D" stroke="#D97706" stroke-width="1.5"/>
</svg>`,
  },
  {
    id: "heart-sketch",
    type: "svg",
    label: "Heart",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40 66 C40 66 12 48 12 28 C12 18 20 12 28 14 C33 15 37 19 40 24 C43 19 47 15 52 14 C60 12 68 18 68 28 C68 48 40 66 40 66Z" fill="#FCA5A5" stroke="#DC2626" stroke-width="2.5" stroke-linejoin="round"/>
<path d="M28 26 C26 30 26 34 28 38" stroke="#F87171" stroke-width="2" stroke-linecap="round" opacity="0.6"/>
</svg>`,
  },
  {
    id: "flower-daisy",
    type: "svg",
    label: "Daisy",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<ellipse cx="40" cy="20" rx="7" ry="14" fill="#FDE68A" stroke="#D97706" stroke-width="1.5"/>
<ellipse cx="40" cy="20" rx="7" ry="14" fill="#FDE68A" stroke="#D97706" stroke-width="1.5" transform="rotate(45 40 40)"/>
<ellipse cx="40" cy="20" rx="7" ry="14" fill="#FDE68A" stroke="#D97706" stroke-width="1.5" transform="rotate(90 40 40)"/>
<ellipse cx="40" cy="20" rx="7" ry="14" fill="#FDE68A" stroke="#D97706" stroke-width="1.5" transform="rotate(135 40 40)"/>
<circle cx="40" cy="40" r="12" fill="#F59E0B" stroke="#D97706" stroke-width="2"/>
<circle cx="40" cy="40" r="6" fill="#FCD34D"/>
</svg>`,
  },
  {
    id: "cherry-blossom",
    type: "svg",
    label: "Blossom",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40 40 C40 40 28 22 36 14 C44 6 48 20 40 40Z" fill="#FBCFE8" stroke="#EC4899" stroke-width="1.5"/>
<path d="M40 40 C40 40 58 28 62 36 C66 44 52 44 40 40Z" fill="#F9A8D4" stroke="#EC4899" stroke-width="1.5"/>
<path d="M40 40 C40 40 52 58 44 62 C36 66 32 52 40 40Z" fill="#FBCFE8" stroke="#EC4899" stroke-width="1.5"/>
<path d="M40 40 C40 40 22 52 18 44 C14 36 28 32 40 40Z" fill="#F9A8D4" stroke="#EC4899" stroke-width="1.5"/>
<circle cx="40" cy="40" r="6" fill="#FCD34D" stroke="#F59E0B" stroke-width="1.5"/>
</svg>`,
  },
  {
    id: "rose",
    type: "svg",
    label: "Rose",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40 16 Q48 22 46 30 Q52 24 56 30 Q56 38 48 40 Q52 46 48 52 Q44 58 40 56 Q36 58 32 52 Q28 46 32 40 Q24 38 24 30 Q28 24 34 30 Q32 22 40 16Z" fill="#FCA5A5" stroke="#DC2626" stroke-width="1.5"/>
<path d="M38 34 Q40 30 42 34" stroke="#F87171" stroke-width="1.5" stroke-linecap="round" opacity="0.6"/>
<path d="M40 56 L40 68" stroke="#16A34A" stroke-width="2" stroke-linecap="round"/>
<path d="M40 62 Q32 58 30 52" stroke="#16A34A" stroke-width="1.5" fill="none" stroke-linecap="round"/>
</svg>`,
  },
  {
    id: "tulip",
    type: "svg",
    label: "Tulip",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40 40 Q30 38 28 26 Q28 14 40 12 Q52 14 52 26 Q50 38 40 40Z" fill="#C4B5FD" stroke="#7C3AED" stroke-width="1.5"/>
<path d="M32 36 Q28 28 30 20" stroke="#A78BFA" stroke-width="1.5" fill="none" opacity="0.5"/>
<path d="M40 40 L40 68" stroke="#16A34A" stroke-width="2.5" stroke-linecap="round"/>
<path d="M40 56 Q30 52 28 44" stroke="#16A34A" stroke-width="1.5" fill="none" stroke-linecap="round"/>
</svg>`,
  },
  {
    id: "lotus",
    type: "svg",
    label: "Lotus",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40 54 Q28 50 24 38 Q30 34 40 40 Q50 34 56 38 Q52 50 40 54Z" fill="#FDE68A" stroke="#D97706" stroke-width="1.5"/>
<path d="M40 40 Q32 28 36 16 Q40 18 40 40Z" fill="#FCA5A5" stroke="#DC2626" stroke-width="1.2"/>
<path d="M40 40 Q48 28 44 16 Q40 18 40 40Z" fill="#FBCFE8" stroke="#DC2626" stroke-width="1.2"/>
<path d="M40 40 Q24 32 20 22 Q26 20 40 40Z" fill="#FDE68A" stroke="#D97706" stroke-width="1.2"/>
<path d="M40 40 Q56 32 60 22 Q54 20 40 40Z" fill="#FEF9C3" stroke="#D97706" stroke-width="1.2"/>
<path d="M26 50 Q20 44 20 36" stroke="#059669" stroke-width="1.5" fill="none" stroke-linecap="round"/>
<path d="M54 50 Q60 44 60 36" stroke="#059669" stroke-width="1.5" fill="none" stroke-linecap="round"/>
</svg>`,
  },
  {
    id: "sunflower",
    type: "svg",
    label: "Sunflower",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="40" cy="36" r="10" fill="#92400E" stroke="#78350F" stroke-width="1.5"/>
<ellipse cx="40" cy="18" rx="6" ry="12" fill="#FDE68A" stroke="#D97706" stroke-width="1.2" transform="rotate(0 40 36)"/>
<ellipse cx="40" cy="18" rx="6" ry="12" fill="#FCD34D" stroke="#D97706" stroke-width="1.2" transform="rotate(45 40 36)"/>
<ellipse cx="40" cy="18" rx="6" ry="12" fill="#FDE68A" stroke="#D97706" stroke-width="1.2" transform="rotate(90 40 36)"/>
<ellipse cx="40" cy="18" rx="6" ry="12" fill="#FCD34D" stroke="#D97706" stroke-width="1.2" transform="rotate(135 40 36)"/>
<ellipse cx="40" cy="18" rx="6" ry="12" fill="#FDE68A" stroke="#D97706" stroke-width="1.2" transform="rotate(180 40 36)"/>
<ellipse cx="40" cy="18" rx="6" ry="12" fill="#FCD34D" stroke="#D97706" stroke-width="1.2" transform="rotate(225 40 36)"/>
<ellipse cx="40" cy="18" rx="6" ry="12" fill="#FDE68A" stroke="#D97706" stroke-width="1.2" transform="rotate(270 40 36)"/>
<ellipse cx="40" cy="18" rx="6" ry="12" fill="#FCD34D" stroke="#D97706" stroke-width="1.2" transform="rotate(315 40 36)"/>
<path d="M40 46 L38 68" stroke="#16A34A" stroke-width="2.5" stroke-linecap="round"/>
<path d="M40 60 Q30 56 28 50" stroke="#16A34A" stroke-width="1.5" fill="none" stroke-linecap="round"/>
</svg>`,
  },
  {
    id: "wildflowers",
    type: "svg",
    label: "Wildflowers",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M30 68 L30 40" stroke="#059669" stroke-width="2" stroke-linecap="round"/>
<path d="M30 50 Q22 46 20 40" stroke="#059669" stroke-width="1.5" fill="none"/>
<circle cx="30" cy="36" r="6" fill="#FCA5A5" stroke="#DC2626" stroke-width="1.5"/>
<path d="M40 68 L40 44" stroke="#16A34A" stroke-width="2" stroke-linecap="round"/>
<circle cx="40" cy="38" r="8" fill="#FDE68A" stroke="#D97706" stroke-width="1.5"/>
<circle cx="40" cy="38" r="4" fill="#F59E0B"/>
<path d="M50 68 L50 42" stroke="#059669" stroke-width="2" stroke-linecap="round"/>
<path d="M50 54 Q58 50 60 44" stroke="#059669" stroke-width="1.5" fill="none"/>
<circle cx="50" cy="36" r="6" fill="#C4B5FD" stroke="#7C3AED" stroke-width="1.5"/>
</svg>`,
  },
  {
    id: "hibiscus",
    type: "svg",
    label: "Hibiscus",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40 40 C40 40 20 30 22 14 C32 12 38 30 40 40Z" fill="#FCA5A5" stroke="#DC2626" stroke-width="1.2"/>
<path d="M40 40 C40 40 56 26 66 28 C68 38 52 42 40 40Z" fill="#F9A8D4" stroke="#DB2777" stroke-width="1.2"/>
<path d="M40 40 C40 40 52 56 46 66 C38 66 36 50 40 40Z" fill="#FCA5A5" stroke="#DC2626" stroke-width="1.2"/>
<path d="M40 40 C40 40 24 54 16 50 C14 40 30 36 40 40Z" fill="#FBCFE8" stroke="#DB2777" stroke-width="1.2"/>
<path d="M40 40 C40 40 34 16 40 10 C46 16 40 40 40 40Z" fill="#F9A8D4" stroke="#DB2777" stroke-width="1.2"/>
<circle cx="40" cy="40" r="5" fill="#FDE68A" stroke="#D97706" stroke-width="1"/>
<path d="M40 35 L40 16" stroke="#FCD34D" stroke-width="1.5" stroke-linecap="round"/>
<circle cx="40" cy="14" r="3" fill="#FCD34D"/>
</svg>`,
  },
  {
    id: "coffee-cup",
    type: "svg",
    label: "Coffee",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 32 L24 64 L56 64 L62 32 Z" fill="#D6B896" stroke="#92400E" stroke-width="2" stroke-linejoin="round"/>
<path d="M60 38 Q70 38 70 46 Q70 54 60 54" stroke="#92400E" stroke-width="2.5" stroke-linecap="round" fill="none"/>
<rect x="18" y="28" width="44" height="8" rx="2" fill="#B45309" stroke="#92400E" stroke-width="1.5"/>
<path d="M30 24 Q30 18 34 16 Q38 14 36 20" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" fill="none"/>
<path d="M40 22 Q40 16 44 14 Q48 12 46 18" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" fill="none" opacity="0.7"/>
</svg>`,
  },
  {
    id: "matcha-latte",
    type: "svg",
    label: "Matcha",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="22" y="32" width="36" height="36" rx="8" fill="#BBF7D0" stroke="#059669" stroke-width="2"/>
<path d="M24 36 L56 36" stroke="#6EE7B7" stroke-width="1.5" stroke-dasharray="3 2"/>
<path d="M58 44 Q68 44 68 50 Q68 56 58 56" stroke="#059669" stroke-width="2" fill="none" stroke-linecap="round"/>
<path d="M32 28 Q30 22 34 18 Q38 14 36 22" stroke="#6B7280" stroke-width="1.8" stroke-linecap="round" fill="none"/>
<path d="M40 26 Q40 20 44 16 Q48 12 46 20" stroke="#6B7280" stroke-width="1.8" stroke-linecap="round" fill="none" opacity="0.6"/>
<text x="40" y="56" text-anchor="middle" font-size="9" fill="#065F46" font-family="sans-serif" font-weight="600">抹茶</text>
</svg>`,
  },
  {
    id: "croissant",
    type: "svg",
    label: "Croissant",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 50 Q16 36 30 30 Q44 24 56 28 Q68 32 68 44 Q68 54 56 56 Q44 60 32 56 Q20 52 12 50Z" fill="#FDE68A" stroke="#D97706" stroke-width="2"/>
<path d="M22 50 Q26 38 38 34 Q50 30 58 34" stroke="#B45309" stroke-width="1.5" fill="none" stroke-linecap="round"/>
<path d="M28 52 Q32 42 42 38 Q52 34 60 38" stroke="#92400E" stroke-width="1" fill="none" stroke-linecap="round" opacity="0.5"/>
<path d="M14 46 Q18 48 16 54" stroke="#D97706" stroke-width="2" fill="none" stroke-linecap="round"/>
<path d="M68 40 Q70 44 66 50" stroke="#D97706" stroke-width="2" fill="none" stroke-linecap="round"/>
</svg>`,
  },
  {
    id: "avocado",
    type: "svg",
    label: "Avocado",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40 8 Q56 12 60 32 Q64 50 52 62 Q44 70 40 70 Q36 70 28 62 Q16 50 20 32 Q24 12 40 8Z" fill="#86EFAC" stroke="#16A34A" stroke-width="2"/>
<path d="M40 20 Q50 22 52 36 Q54 48 46 56 Q44 60 40 60 Q36 60 34 56 Q26 48 28 36 Q30 22 40 20Z" fill="#FEF9C3" stroke="#D97706" stroke-width="1.5"/>
<circle cx="40" cy="42" r="10" fill="#D97706" stroke="#92400E" stroke-width="1.5"/>
<path d="M40 12 L40 6" stroke="#16A34A" stroke-width="2" stroke-linecap="round"/>
</svg>`,
  },
  {
    id: "tea-cup",
    type: "svg",
    label: "Tea",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 36 L24 64 L56 64 L64 36 Z" fill="#FEF3C7" stroke="#D97706" stroke-width="2"/>
<path d="M62 42 Q72 42 72 50 Q72 58 62 58" stroke="#D97706" stroke-width="2" fill="none" stroke-linecap="round"/>
<rect x="16" y="32" width="48" height="8" rx="3" fill="#F59E0B" stroke="#D97706" stroke-width="1.5"/>
<path d="M28 28 L52 28" stroke="#D97706" stroke-width="1.5" stroke-linecap="round"/>
<path d="M24 28 Q24 22 32 18" stroke="#9CA3AF" stroke-width="2" fill="none" stroke-linecap="round"/>
<path d="M40 24 Q38 18 42 14" stroke="#9CA3AF" stroke-width="2" fill="none" stroke-linecap="round" opacity="0.6"/>
<path d="M56 28 Q60 22 54 18" stroke="#9CA3AF" stroke-width="2" fill="none" stroke-linecap="round" opacity="0.4"/>
</svg>`,
  },
  {
    id: "fruit-bowl",
    type: "svg",
    label: "Fruit bowl",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 56 Q12 64 40 64 Q68 64 68 56 Q68 48 40 48 Q12 48 12 56Z" fill="#FDE68A" stroke="#D97706" stroke-width="2"/>
<circle cx="28" cy="46" r="10" fill="#FCA5A5" stroke="#DC2626" stroke-width="1.5"/>
<circle cx="40" cy="42" r="10" fill="#FDE68A" stroke="#D97706" stroke-width="1.5"/>
<circle cx="52" cy="44" r="10" fill="#86EFAC" stroke="#16A34A" stroke-width="1.5"/>
<path d="M28 36 L26 28" stroke="#16A34A" stroke-width="1.5" stroke-linecap="round"/>
<path d="M40 32 L40 24" stroke="#16A34A" stroke-width="1.5" stroke-linecap="round"/>
<path d="M52 34 L54 26" stroke="#16A34A" stroke-width="1.5" stroke-linecap="round"/>
</svg>`,
  },
  {
    id: "lightning",
    type: "svg",
    label: "Lightning",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M46 8 L22 46 L40 46 L34 72 L58 34 L42 34 Z" fill="#FDE68A" stroke="#D97706" stroke-width="2.5" stroke-linejoin="round"/>
</svg>`,
  },
  {
    id: "moon",
    type: "svg",
    label: "Moon",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M50 16 Q28 20 28 40 Q28 60 50 64 Q36 68 26 58 Q14 46 14 36 Q14 18 28 12 Q40 8 50 16Z" fill="#FEF3C7" stroke="#D97706" stroke-width="2" stroke-linejoin="round"/>
<circle cx="36" cy="32" r="3" fill="#FCD34D" opacity="0.5"/>
<circle cx="44" cy="50" r="2" fill="#FCD34D" opacity="0.4"/>
</svg>`,
  },
  {
    id: "leaf",
    type: "svg",
    label: "Leaf",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40 70 Q40 70 20 50 Q8 36 16 18 Q24 4 40 10 Q56 4 64 18 Q72 36 60 50 Q40 70 40 70Z" fill="#6EE7B7" stroke="#059669" stroke-width="2" stroke-linejoin="round"/>
<path d="M40 70 L40 10" stroke="#059669" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/>
<path d="M40 50 Q28 44 22 34" stroke="#059669" stroke-width="1.2" stroke-linecap="round" opacity="0.5"/>
<path d="M40 40 Q52 34 58 24" stroke="#059669" stroke-width="1.2" stroke-linecap="round" opacity="0.5"/>
</svg>`,
  },
  {
    id: "crown",
    type: "svg",
    label: "Crown",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 58 L10 40 L22 52 L40 18 L58 52 L70 40 L70 58 Z" fill="#FDE68A" stroke="#D97706" stroke-width="2.5" stroke-linejoin="round"/>
<rect x="10" y="56" width="60" height="10" rx="2" fill="#D97706"/>
<circle cx="40" cy="18" r="4" fill="#EF4444"/>
<circle cx="10" cy="40" r="3.5" fill="#EF4444"/>
<circle cx="70" cy="40" r="3.5" fill="#EF4444"/>
</svg>`,
  },
  {
    id: "rainbow",
    type: "svg",
    label: "Rainbow",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 56 Q8 20 40 20 Q72 20 72 56" stroke="#EF4444" stroke-width="6" fill="none" stroke-linecap="round"/>
<path d="M14 56 Q14 26 40 26 Q66 26 66 56" stroke="#F97316" stroke-width="5" fill="none" stroke-linecap="round"/>
<path d="M20 56 Q20 32 40 32 Q60 32 60 56" stroke="#EAB308" stroke-width="5" fill="none" stroke-linecap="round"/>
<path d="M26 56 Q26 38 40 38 Q54 38 54 56" stroke="#22C55E" stroke-width="5" fill="none" stroke-linecap="round"/>
<path d="M32 56 Q32 44 40 44 Q48 44 48 56" stroke="#3B82F6" stroke-width="5" fill="none" stroke-linecap="round"/>
</svg>`,
  },
  {
    id: "sparkle",
    type: "svg",
    label: "Sparkle",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40 10 L42 36 L68 38 L42 40 L40 70 L38 40 L12 38 L38 36 Z" fill="#E9D5FF" stroke="#8B5CF6" stroke-width="1.5" stroke-linejoin="round"/>
<path d="M20 14 L21 24 L30 25 L21 26 L20 36 L19 26 L10 25 L19 24Z" fill="#DDD6FE" stroke="#8B5CF6" stroke-width="1" stroke-linejoin="round"/>
<path d="M60 50 L61 58 L68 59 L61 60 L60 68 L59 60 L52 59 L59 58Z" fill="#DDD6FE" stroke="#8B5CF6" stroke-width="1" stroke-linejoin="round"/>
</svg>`,
  },
  {
    id: "mountain",
    type: "svg",
    label: "Mountain",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40 12 L68 64 L12 64 Z" fill="#C4B5FD" stroke="#7C3AED" stroke-width="2" stroke-linejoin="round"/>
<path d="M54 36 L68 64 L40 64 Z" fill="#A78BFA" stroke="#7C3AED" stroke-width="1.5" stroke-linejoin="round"/>
<path d="M33 26 L44 12 L55 26 L49 22 L44 28 L39 22Z" fill="white" stroke="#DDD6FE" stroke-width="1"/>
</svg>`,
  },
  {
    id: "sun",
    type: "svg",
    label: "Sun",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="40" cy="40" r="16" fill="#FDE68A" stroke="#D97706" stroke-width="2"/>
<line x1="40" y1="18" x2="40" y2="12" stroke="#D97706" stroke-width="2.5" stroke-linecap="round"/>
<line x1="40" y1="62" x2="40" y2="68" stroke="#D97706" stroke-width="2.5" stroke-linecap="round"/>
<line x1="18" y1="40" x2="12" y2="40" stroke="#D97706" stroke-width="2.5" stroke-linecap="round"/>
<line x1="62" y1="40" x2="68" y2="40" stroke="#D97706" stroke-width="2.5" stroke-linecap="round"/>
<line x1="24.9" y1="24.9" x2="20.6" y2="20.6" stroke="#D97706" stroke-width="2.5" stroke-linecap="round"/>
<line x1="55.1" y1="55.1" x2="59.4" y2="59.4" stroke="#D97706" stroke-width="2.5" stroke-linecap="round"/>
<line x1="55.1" y1="24.9" x2="59.4" y2="20.6" stroke="#D97706" stroke-width="2.5" stroke-linecap="round"/>
<line x1="24.9" y1="55.1" x2="20.6" y2="59.4" stroke="#D97706" stroke-width="2.5" stroke-linecap="round"/>
</svg>`,
  },
  {
    id: "cloud",
    type: "svg",
    label: "Cloud",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="28" cy="46" r="14" fill="white" stroke="#9CA3AF" stroke-width="2"/>
<circle cx="42" cy="40" r="18" fill="white" stroke="#9CA3AF" stroke-width="2"/>
<circle cx="56" cy="46" r="12" fill="white" stroke="#9CA3AF" stroke-width="2"/>
<rect x="16" y="46" width="52" height="14" rx="2" fill="white"/>
</svg>`,
  },
  {
    id: "bird",
    type: "svg",
    label: "Bird",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 44 Q18 30 30 34 Q40 38 44 30 Q50 20 62 22 Q56 30 52 38 Q60 36 68 40 Q60 44 52 42 Q48 50 40 52 Q30 54 24 50 Q16 52 8 44Z" fill="#BAE6FD" stroke="#0284C7" stroke-width="1.8" stroke-linejoin="round"/>
<circle cx="60" cy="26" r="3" fill="#1E3A5F"/>
<path d="M62 24 L68 20" stroke="#0284C7" stroke-width="2" stroke-linecap="round"/>
</svg>`,
  },
  {
    id: "pencil",
    type: "svg",
    label: "Pencil",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 56 L60 16 L68 24 L28 64 Z" fill="#FDE68A" stroke="#D97706" stroke-width="2" stroke-linejoin="round"/>
<path d="M20 56 L28 64 L14 68 Z" fill="#F87171" stroke="#DC2626" stroke-width="1.5" stroke-linejoin="round"/>
<path d="M56 20 L64 28" stroke="#D97706" stroke-width="2" opacity="0.5"/>
<path d="M16 60 L22 62 L18 66Z" fill="#1F2937"/>
</svg>`,
  },
  {
    id: "plant-sprout",
    type: "svg",
    label: "Sprout",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40 64 L40 32" stroke="#059669" stroke-width="3" stroke-linecap="round"/>
<path d="M40 48 Q26 42 22 26 Q36 24 40 38" fill="#6EE7B7" stroke="#059669" stroke-width="1.5"/>
<path d="M40 40 Q54 34 58 18 Q44 16 40 32" fill="#34D399" stroke="#059669" stroke-width="1.5"/>
<ellipse cx="40" cy="66" rx="12" ry="4" fill="#A78BFA" stroke="#7C3AED" stroke-width="1.5" opacity="0.4"/>
</svg>`,
  },
  {
    id: "butterfly",
    type: "svg",
    label: "Butterfly",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40 40 Q30 30 16 26 Q10 36 18 44 Q26 52 40 40Z" fill="#C4B5FD" stroke="#7C3AED" stroke-width="1.5"/>
<path d="M40 40 Q50 30 64 26 Q70 36 62 44 Q54 52 40 40Z" fill="#DDD6FE" stroke="#7C3AED" stroke-width="1.5"/>
<path d="M40 40 Q32 46 20 50 Q18 60 28 60 Q36 58 40 40Z" fill="#A78BFA" stroke="#7C3AED" stroke-width="1.5"/>
<path d="M40 40 Q48 46 60 50 Q62 60 52 60 Q44 58 40 40Z" fill="#C4B5FD" stroke="#7C3AED" stroke-width="1.5"/>
<path d="M40 26 Q40 40 40 54" stroke="#4C1D95" stroke-width="2" stroke-linecap="round"/>
</svg>`,
  },
  {
    id: "gem",
    type: "svg",
    label: "Gem",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M28 20 L52 20 L68 38 L40 68 L12 38 Z" fill="#BAE6FD" stroke="#0284C7" stroke-width="2" stroke-linejoin="round"/>
<path d="M28 20 L40 38 L12 38 Z" fill="#7DD3FC" opacity="0.6"/>
<path d="M52 20 L40 38 L68 38 Z" fill="#38BDF8" opacity="0.6"/>
<path d="M28 20 L52 20" stroke="white" stroke-width="2" stroke-linecap="round" opacity="0.7"/>
</svg>`,
  },
  {
    id: "fire",
    type: "svg",
    label: "Fire",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40 8 Q48 20 44 28 Q52 18 56 28 Q64 16 60 32 Q68 28 64 44 Q68 56 56 62 Q48 68 40 68 Q32 68 24 62 Q12 56 16 44 Q12 28 20 32 Q16 16 24 28 Q28 18 36 28 Q32 20 40 8Z" fill="#FDE68A" stroke="#D97706" stroke-width="1.5" stroke-linejoin="round"/>
<path d="M40 28 Q44 36 42 44 Q46 38 48 44 Q52 36 48 52 Q44 60 40 60 Q36 60 32 52 Q28 36 32 44 Q34 38 38 44 Q36 36 40 28Z" fill="#FCA5A5" stroke="#DC2626" stroke-width="1" stroke-linejoin="round"/>
</svg>`,
  },
  {
    id: "speech-bubble",
    type: "svg",
    label: "Bubble",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 14 L70 14 Q72 14 72 16 L72 52 Q72 54 70 54 L28 54 L16 68 L16 54 L10 54 Q8 54 8 52 L8 16 Q8 14 10 14Z" fill="#FEF9C3" stroke="#D97706" stroke-width="2" stroke-linejoin="round"/>
<line x1="22" y1="28" x2="56" y2="28" stroke="#D97706" stroke-width="2" stroke-linecap="round" opacity="0.5"/>
<line x1="22" y1="38" x2="48" y2="38" stroke="#D97706" stroke-width="2" stroke-linecap="round" opacity="0.5"/>
</svg>`,
  },
  {
    id: "arrow-sketch",
    type: "svg",
    label: "Arrow",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 40 Q30 20 58 36" stroke="#1F2937" stroke-width="3" stroke-linecap="round" fill="none" stroke-dasharray="3 2"/>
<path d="M50 26 L62 36 L52 46" stroke="#1F2937" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
</svg>`,
  },
  {
    id: "washi-tape-x",
    type: "svg",
    label: "Tape",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="30" width="72" height="20" rx="4" fill="#DDD6FE" opacity="0.7"/>
<path d="M4 30 L76 30" stroke="#A78BFA" stroke-width="1" stroke-dasharray="4 3"/>
<path d="M4 50 L76 50" stroke="#A78BFA" stroke-width="1" stroke-dasharray="4 3"/>
</svg>`,
  },
  {
    id: "paperclip",
    type: "svg",
    label: "Paperclip",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M48 20 Q60 20 60 32 Q60 60 40 68 Q20 60 20 40 L20 28 Q20 16 32 16 Q44 16 44 28 L44 52 Q44 58 40 58 Q36 58 36 52 L36 32" stroke="#6B7280" stroke-width="3" fill="none" stroke-linecap="round"/>
</svg>`,
  },
  {
    id: "polaroid",
    type: "svg",
    label: "Polaroid",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="14" y="10" width="52" height="60" rx="3" fill="white" stroke="#D1D5DB" stroke-width="2"/>
<rect x="20" y="16" width="40" height="36" rx="2" fill="#E5E7EB"/>
<rect x="20" y="56" width="40" height="10" rx="1" fill="white"/>
<line x1="28" y1="61" x2="52" y2="61" stroke="#D1D5DB" stroke-width="1.5" stroke-linecap="round"/>
</svg>`,
  },
  {
    id: "stamp",
    type: "svg",
    label: "Stamp",
    content: `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="12" y="12" width="56" height="56" rx="4" fill="none" stroke="#7C3AED" stroke-width="3" stroke-dasharray="5 3"/>
<rect x="20" y="20" width="40" height="40" rx="3" fill="#EDE9FE" stroke="#7C3AED" stroke-width="2"/>
<text x="40" y="35" text-anchor="middle" font-size="9" fill="#7C3AED" font-family="sans-serif" font-weight="700">JOURNAL</text>
<text x="40" y="47" text-anchor="middle" font-size="7" fill="#8B5CF6" font-family="sans-serif">✦ ENTRY ✦</text>
<text x="40" y="57" text-anchor="middle" font-size="7" fill="#7C3AED" font-family="sans-serif">2026</text>
</svg>`,
  },
];

// ─── Quote / Motivational Badge Stickers ─────────────────────────────────────

export const QUOTE_STICKERS: StickerItem[] = [
  {
    id: "q-life-beautiful",
    type: "svg",
    label: "Life is Beautiful",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<ellipse cx="60" cy="60" rx="56" ry="50" fill="#86EFAC" stroke="#16A34A" stroke-width="2.5"/>
<path d="M20 40 Q30 28 60 26 Q90 28 100 40" fill="none" stroke="#4ADE80" stroke-width="1.5" opacity="0.5"/>
<path d="M20 80 Q30 92 60 94 Q90 92 100 80" fill="none" stroke="#4ADE80" stroke-width="1.5" opacity="0.5"/>
<text x="60" y="52" text-anchor="middle" font-size="13" fill="#14532D" font-family="Georgia, serif" font-style="italic">Life is</text>
<text x="60" y="70" text-anchor="middle" font-size="16" fill="#14532D" font-family="Georgia, serif" font-weight="bold" font-style="italic">Beautiful</text>
</svg>`,
  },
  {
    id: "q-slow-down",
    type: "svg",
    label: "Slow Down",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="60" cy="60" r="54" fill="#FDE68A" stroke="#D97706" stroke-width="2"/>
<path d="M22 50 Q28 38 40 32 Q52 26 60 26 Q68 26 80 32 Q92 38 98 50" fill="none" stroke="#D97706" stroke-width="1.2" opacity="0.4"/>
<path d="M22 70 Q28 82 40 88 Q52 94 60 94 Q68 94 80 88 Q92 82 98 70" fill="none" stroke="#D97706" stroke-width="1.2" opacity="0.4"/>
<text x="60" y="48" text-anchor="middle" font-size="11" fill="#92400E" font-family="Georgia, serif" font-weight="bold">SLOW DOWN</text>
<text x="60" y="62" text-anchor="middle" font-size="9.5" fill="#78350F" font-family="Georgia, serif">You're doing</text>
<text x="60" y="76" text-anchor="middle" font-size="13" fill="#92400E" font-family="Georgia, serif" font-weight="bold">just fine</text>
</svg>`,
  },
  {
    id: "q-setback",
    type: "svg",
    label: "Setback not failure",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="8" y="20" width="104" height="80" rx="8" fill="#FEF9C3" stroke="#D97706" stroke-width="2"/>
<rect x="8" y="20" width="104" height="16" rx="8" fill="#D97706"/>
<line x1="8" y1="28" x2="112" y2="28" stroke="#B45309" stroke-width="1"/>
<text x="60" y="33" text-anchor="middle" font-size="8" fill="white" font-family="sans-serif" font-weight="700">REMINDER</text>
<text x="60" y="58" text-anchor="middle" font-size="11" fill="#78350F" font-family="Georgia, serif" font-style="italic">Set back is</text>
<text x="60" y="72" text-anchor="middle" font-size="11" fill="#78350F" font-family="Georgia, serif" font-style="italic">not failure</text>
<line x1="24" y1="85" x2="96" y2="85" stroke="#D97706" stroke-width="1" stroke-dasharray="4 3"/>
<line x1="24" y1="92" x2="80" y2="92" stroke="#D97706" stroke-width="1" stroke-dasharray="4 3"/>
</svg>`,
  },
  {
    id: "q-sunshine",
    type: "svg",
    label: "Be Your Sunshine",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="10" width="108" height="100" rx="12" fill="#D1FAE5" stroke="#059669" stroke-width="2"/>
<circle cx="60" cy="30" r="14" fill="#FDE68A" stroke="#D97706" stroke-width="1.5"/>
<line x1="60" y1="12" x2="60" y2="8" stroke="#D97706" stroke-width="2" stroke-linecap="round"/>
<line x1="76" y1="16" x2="79" y2="13" stroke="#D97706" stroke-width="2" stroke-linecap="round"/>
<line x1="82" y1="30" x2="86" y2="30" stroke="#D97706" stroke-width="2" stroke-linecap="round"/>
<line x1="44" y1="16" x2="41" y2="13" stroke="#D97706" stroke-width="2" stroke-linecap="round"/>
<line x1="38" y1="30" x2="34" y2="30" stroke="#D97706" stroke-width="2" stroke-linecap="round"/>
<text x="60" y="64" text-anchor="middle" font-size="9.5" fill="#065F46" font-family="Georgia, serif" font-style="italic">Be Your</text>
<text x="60" y="78" text-anchor="middle" font-size="12" fill="#065F46" font-family="Georgia, serif" font-weight="bold">Very Own</text>
<text x="60" y="94" text-anchor="middle" font-size="12" fill="#065F46" font-family="Georgia, serif" font-weight="bold">Sunshine</text>
</svg>`,
  },
  {
    id: "q-keep-going",
    type: "svg",
    label: "Keep Going",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="60" cy="60" r="54" fill="#EDE9FE" stroke="#7C3AED" stroke-width="3"/>
<circle cx="60" cy="60" r="46" fill="none" stroke="#A78BFA" stroke-width="1.5" stroke-dasharray="5 4"/>
<text x="60" y="52" text-anchor="middle" font-size="10" fill="#5B21B6" font-family="sans-serif" font-weight="700" letter-spacing="3">KEEP</text>
<text x="60" y="70" text-anchor="middle" font-size="18" fill="#7C3AED" font-family="Georgia, serif" font-weight="bold">Going</text>
<text x="60" y="84" text-anchor="middle" font-size="8" fill="#8B5CF6" font-family="sans-serif" letter-spacing="2">✦ ✦ ✦</text>
</svg>`,
  },
  {
    id: "q-you-got-this",
    type: "svg",
    label: "You Got This",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M60 8 L110 35 L110 85 L60 112 L10 85 L10 35 Z" fill="#DBEAFE" stroke="#2563EB" stroke-width="2.5"/>
<path d="M60 18 L100 40 L100 80 L60 102 L20 80 L20 40 Z" fill="none" stroke="#93C5FD" stroke-width="1" stroke-dasharray="4 3"/>
<text x="60" y="53" text-anchor="middle" font-size="10" fill="#1D4ED8" font-family="sans-serif" font-weight="700">YOU</text>
<text x="60" y="68" text-anchor="middle" font-size="10" fill="#1D4ED8" font-family="sans-serif" font-weight="700">GOT</text>
<text x="60" y="83" text-anchor="middle" font-size="10" fill="#1D4ED8" font-family="sans-serif" font-weight="700">THIS</text>
</svg>`,
  },
  {
    id: "q-every-day-dream",
    type: "svg",
    label: "Every Day a Dream",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="8" y="18" width="104" height="84" rx="16" fill="#FEF3C7" stroke="#F59E0B" stroke-width="2.5"/>
<text x="60" y="48" text-anchor="middle" font-size="9" fill="#78350F" font-family="sans-serif" font-weight="800" letter-spacing="2">EVERY</text>
<text x="60" y="64" text-anchor="middle" font-size="9" fill="#78350F" font-family="sans-serif" font-weight="800" letter-spacing="2">DAY IS</text>
<text x="60" y="80" text-anchor="middle" font-size="9" fill="#78350F" font-family="sans-serif" font-weight="800" letter-spacing="2">A DREAM</text>
<path d="M20 88 L100 88" stroke="#F59E0B" stroke-width="1.5" stroke-linecap="round"/>
<text x="60" y="99" text-anchor="middle" font-size="7" fill="#B45309" font-family="sans-serif">~ believe it ~</text>
</svg>`,
  },
  {
    id: "q-trust-process",
    type: "svg",
    label: "Trust the Process",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="30" width="108" height="60" rx="6" fill="#F3E8FF" stroke="#9333EA" stroke-width="2"/>
<rect x="6" y="30" width="108" height="60" rx="6" fill="none" stroke="#C4B5FD" stroke-width="1" stroke-dasharray="0" transform="translate(4 4)" opacity="0.4"/>
<text x="60" y="57" text-anchor="middle" font-size="10" fill="#581C87" font-family="Georgia, serif" font-style="italic">Trust</text>
<text x="60" y="72" text-anchor="middle" font-size="10" fill="#581C87" font-family="Georgia, serif" font-style="italic">the Process</text>
<text x="60" y="84" text-anchor="middle" font-size="7" fill="#7E22CE" font-family="sans-serif" letter-spacing="2">✦ ✦ ✦</text>
</svg>`,
  },
  {
    id: "q-progress",
    type: "svg",
    label: "Progress not Perfection",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="10" width="108" height="100" rx="10" fill="#FFF7ED" stroke="#EA580C" stroke-width="2"/>
<rect x="6" y="10" width="108" height="22" rx="10" fill="#EA580C"/>
<rect x="6" y="24" width="108" height="8" fill="#C2410C"/>
<text x="60" y="27" text-anchor="middle" font-size="8" fill="white" font-family="sans-serif" font-weight="700" letter-spacing="1">DAILY REMINDER</text>
<text x="60" y="54" text-anchor="middle" font-size="11" fill="#7C2D12" font-family="Georgia, serif" font-style="italic">Progress,</text>
<text x="60" y="70" text-anchor="middle" font-size="9" fill="#9A3412" font-family="sans-serif">not perfection</text>
<path d="M26 88 L94 88" stroke="#FB923C" stroke-width="1.5"/>
<text x="60" y="100" text-anchor="middle" font-size="7.5" fill="#C2410C" font-family="sans-serif">one step at a time</text>
</svg>`,
  },
  {
    id: "q-rest-productive",
    type: "svg",
    label: "Rest is Productive",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<ellipse cx="60" cy="68" rx="52" ry="40" fill="#BAE6FD" stroke="#0284C7" stroke-width="2"/>
<ellipse cx="60" cy="50" rx="44" ry="32" fill="#E0F2FE" stroke="#38BDF8" stroke-width="1.5"/>
<path d="M28 60 Q32 44 60 44 Q88 44 92 60" fill="white" stroke="#93C5FD" stroke-width="1.5"/>
<text x="60" y="60" text-anchor="middle" font-size="9" fill="#0C4A6E" font-family="Georgia, serif" font-style="italic">Rest is</text>
<text x="60" y="74" text-anchor="middle" font-size="11" fill="#0C4A6E" font-family="Georgia, serif" font-weight="bold">productive</text>
</svg>`,
  },
  {
    id: "q-feelings-valid",
    type: "svg",
    label: "Feelings are Valid",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M60 110 Q20 88 14 60 Q8 32 26 18 Q40 8 60 18 Q80 8 94 18 Q112 32 106 60 Q100 88 60 110Z" fill="#FCE7F3" stroke="#DB2777" stroke-width="2"/>
<path d="M60 96 Q30 78 26 58 Q22 38 36 28 Q48 20 60 30 Q72 20 84 28 Q98 38 94 58 Q90 78 60 96Z" fill="#FBCFE8" stroke="#EC4899" stroke-width="1" opacity="0.6"/>
<text x="60" y="54" text-anchor="middle" font-size="9" fill="#831843" font-family="Georgia, serif" font-style="italic">Your feelings</text>
<text x="60" y="68" text-anchor="middle" font-size="9" fill="#831843" font-family="Georgia, serif" font-style="italic">are valid</text>
</svg>`,
  },
  {
    id: "q-breathe",
    type: "svg",
    label: "Breathe",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="60" cy="60" r="54" fill="none" stroke="#A78BFA" stroke-width="1.5" stroke-dasharray="6 4"/>
<circle cx="60" cy="60" r="44" fill="#EDE9FE" stroke="#8B5CF6" stroke-width="2"/>
<circle cx="60" cy="60" r="34" fill="none" stroke="#C4B5FD" stroke-width="1.5" opacity="0.6"/>
<text x="60" y="52" text-anchor="middle" font-size="9" fill="#5B21B6" font-family="sans-serif" letter-spacing="3">BREATHE</text>
<text x="60" y="64" text-anchor="middle" font-size="8" fill="#6D28D9" font-family="sans-serif">in · · · out</text>
<text x="60" y="78" text-anchor="middle" font-size="9" fill="#7C3AED" font-family="Georgia, serif" font-style="italic">you're safe</text>
</svg>`,
  },
  {
    id: "q-its-okay",
    type: "svg",
    label: "It's okay",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="10" y="14" width="100" height="92" rx="10" fill="#F0FDF4" stroke="#16A34A" stroke-width="2"/>
<path d="M10 14 L30 14 Q30 34 10 34Z" fill="#DCFCE7" stroke="none"/>
<text x="60" y="55" text-anchor="middle" font-size="11" fill="#14532D" font-family="Georgia, serif" font-style="italic">It's okay to</text>
<text x="60" y="70" text-anchor="middle" font-size="11" fill="#14532D" font-family="Georgia, serif" font-style="italic">not be okay.</text>
<path d="M30 85 L90 85" stroke="#22C55E" stroke-width="1.5"/>
<text x="60" y="96" text-anchor="middle" font-size="7.5" fill="#15803D" font-family="sans-serif">you are still growing</text>
</svg>`,
  },
  {
    id: "q-si-se-puede",
    type: "svg",
    label: "¡Sí se puede!",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="10" width="108" height="100" rx="12" fill="#FEF9C3" stroke="#D97706" stroke-width="2.5"/>
<rect x="6" y="10" width="108" height="28" rx="12" fill="#16A34A"/>
<rect x="6" y="30" width="108" height="8" fill="#16A34A"/>
<rect x="6" y="82" width="108" height="28" rx="0" fill="#DC2626"/>
<rect x="6" y="98" width="108" height="12" rx="12" fill="#DC2626"/>
<text x="60" y="30" text-anchor="middle" font-size="9" fill="white" font-family="sans-serif" font-weight="800">🇲🇽</text>
<text x="60" y="60" text-anchor="middle" font-size="13" fill="#78350F" font-family="Georgia, serif" font-weight="bold" font-style="italic">¡Sí se</text>
<text x="60" y="76" text-anchor="middle" font-size="13" fill="#78350F" font-family="Georgia, serif" font-weight="bold" font-style="italic">puede!</text>
<text x="60" y="97" text-anchor="middle" font-size="8" fill="white" font-family="sans-serif" font-weight="600">Yes, you can!</text>
</svg>`,
  },
  {
    id: "q-ca-va-aller",
    type: "svg",
    label: "Ça va aller",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="16" width="108" height="88" rx="14" fill="#F0F9FF" stroke="#0284C7" stroke-width="2"/>
<path d="M20 30 Q60 18 100 30" fill="none" stroke="#BAE6FD" stroke-width="1.5"/>
<path d="M20 90 Q60 102 100 90" fill="none" stroke="#BAE6FD" stroke-width="1.5"/>
<text x="60" y="44" text-anchor="middle" font-size="8" fill="#0369A1" font-family="sans-serif" font-weight="600">🇫🇷 en français</text>
<text x="60" y="60" text-anchor="middle" font-size="14" fill="#0C4A6E" font-family="Georgia, serif" font-style="italic">Ça va</text>
<text x="60" y="76" text-anchor="middle" font-size="14" fill="#0C4A6E" font-family="Georgia, serif" font-style="italic">aller.</text>
<text x="60" y="92" text-anchor="middle" font-size="7.5" fill="#0369A1" font-family="sans-serif">It'll be alright.</text>
</svg>`,
  },
  {
    id: "q-ganbatte",
    type: "svg",
    label: "頑張って",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="60" cy="60" r="54" fill="#FEF2F2" stroke="#DC2626" stroke-width="4"/>
<circle cx="60" cy="60" r="48" fill="none" stroke="#FCA5A5" stroke-width="1.5"/>
<text x="60" y="52" text-anchor="middle" font-size="24" fill="#DC2626" font-family="serif" font-weight="bold">頑</text>
<text x="60" y="76" text-anchor="middle" font-size="24" fill="#DC2626" font-family="serif" font-weight="bold">張</text>
<text x="60" y="98" text-anchor="middle" font-size="8" fill="#B91C1C" font-family="sans-serif">Ganbatte! (Do your best!)</text>
</svg>`,
  },
  {
    id: "q-bella-vita",
    type: "svg",
    label: "Bella vita",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="8" y="16" width="104" height="88" rx="10" fill="#FFFBEB" stroke="#D97706" stroke-width="2"/>
<path d="M18 28 Q60 20 102 28 Q102 28 96 24 Q60 16 24 24Z" fill="#D97706" opacity="0.3"/>
<path d="M18 92 Q60 100 102 92 Q96 96 60 104 Q24 96 18 92Z" fill="#D97706" opacity="0.3"/>
<text x="60" y="44" text-anchor="middle" font-size="8" fill="#92400E" font-family="sans-serif" letter-spacing="2">🇮🇹 italiano</text>
<text x="60" y="62" text-anchor="middle" font-size="16" fill="#78350F" font-family="Georgia, serif" font-style="italic">Bella</text>
<text x="60" y="80" text-anchor="middle" font-size="16" fill="#78350F" font-family="Georgia, serif" font-style="italic">vita</text>
<text x="60" y="94" text-anchor="middle" font-size="7.5" fill="#B45309" font-family="sans-serif">Beautiful life ✦</text>
</svg>`,
  },
  {
    id: "q-amor-fati",
    type: "svg",
    label: "Amor Fati",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="60" cy="60" r="54" fill="#F5F3FF" stroke="#6D28D9" stroke-width="2.5"/>
<path d="M18 44 Q40 30 60 30 Q80 30 102 44" fill="none" stroke="#8B5CF6" stroke-width="1" opacity="0.4"/>
<path d="M18 76 Q40 90 60 90 Q80 90 102 76" fill="none" stroke="#8B5CF6" stroke-width="1" opacity="0.4"/>
<text x="60" y="48" text-anchor="middle" font-size="8" fill="#5B21B6" font-family="sans-serif" letter-spacing="1">Latin · stoic</text>
<text x="60" y="65" text-anchor="middle" font-size="16" fill="#4C1D95" font-family="Georgia, serif" font-style="italic">Amor</text>
<text x="60" y="81" text-anchor="middle" font-size="16" fill="#4C1D95" font-family="Georgia, serif" font-style="italic">Fati</text>
<text x="60" y="96" text-anchor="middle" font-size="7" fill="#6D28D9" font-family="sans-serif">Love your fate ✦</text>
</svg>`,
  },
  {
    id: "q-good-vibes",
    type: "svg",
    label: "Good Vibes",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="14" width="108" height="92" rx="22" fill="#ECFDF5" stroke="#059669" stroke-width="2.5"/>
<path d="M20 40 L100 40" stroke="#6EE7B7" stroke-width="1.2" stroke-dasharray="4 3"/>
<path d="M20 80 L100 80" stroke="#6EE7B7" stroke-width="1.2" stroke-dasharray="4 3"/>
<text x="60" y="58" text-anchor="middle" font-size="11" fill="#064E3B" font-family="sans-serif" font-weight="800" letter-spacing="1">GOOD</text>
<text x="60" y="74" text-anchor="middle" font-size="11" fill="#065F46" font-family="sans-serif" font-weight="800" letter-spacing="1">VIBES</text>
<text x="60" y="88" text-anchor="middle" font-size="7.5" fill="#059669" font-family="sans-serif" letter-spacing="3">ONLY ✦</text>
</svg>`,
  },
  {
    id: "q-self-love",
    type: "svg",
    label: "Self Love First",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M60 108 Q14 82 12 52 Q10 22 30 14 Q46 8 60 24 Q74 8 90 14 Q110 22 108 52 Q106 82 60 108Z" fill="#FCE7F3" stroke="#DB2777" stroke-width="2.5"/>
<path d="M60 96 Q24 74 22 52 Q20 30 36 24 Q50 18 60 34 Q70 18 84 24 Q100 30 98 52 Q96 74 60 96Z" fill="#FBCFE8" stroke="#EC4899" stroke-width="1" opacity="0.5"/>
<text x="60" y="56" text-anchor="middle" font-size="9.5" fill="#831843" font-family="Georgia, serif" font-style="italic">Self love</text>
<text x="60" y="70" text-anchor="middle" font-size="9.5" fill="#831843" font-family="Georgia, serif" font-style="italic">is not selfish</text>
</svg>`,
  },
  {
    id: "q-i-choose-joy",
    type: "svg",
    label: "I Choose Joy",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="60" cy="60" r="54" fill="#FEFCE8" stroke="#CA8A04" stroke-width="2.5"/>
<circle cx="60" cy="60" r="44" fill="none" stroke="#FDE047" stroke-width="6" opacity="0.5"/>
<text x="60" y="50" text-anchor="middle" font-size="10" fill="#713F12" font-family="sans-serif" font-weight="700">I choose</text>
<text x="60" y="66" text-anchor="middle" font-size="18" fill="#92400E" font-family="Georgia, serif" font-weight="bold">Joy</text>
<text x="60" y="82" text-anchor="middle" font-size="9" fill="#A16207" font-family="sans-serif" font-style="italic">every single day</text>
</svg>`,
  },
  {
    id: "q-be-kind-self",
    type: "svg",
    label: "Be kind to yourself",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="8" y="12" width="104" height="96" rx="16" fill="#FFF1F2" stroke="#F43F5E" stroke-width="2"/>
<text x="60" y="42" text-anchor="middle" font-size="18" fill="#F43F5E">♡</text>
<text x="60" y="62" text-anchor="middle" font-size="9.5" fill="#881337" font-family="Georgia, serif" font-style="italic">Be kind</text>
<text x="60" y="76" text-anchor="middle" font-size="9.5" fill="#881337" font-family="Georgia, serif" font-style="italic">to yourself</text>
<text x="60" y="92" text-anchor="middle" font-size="7.5" fill="#BE123C" font-family="sans-serif">always ✦</text>
</svg>`,
  },
  {
    id: "q-dream-big",
    type: "svg",
    label: "Dream Big",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="8" y="14" width="104" height="92" rx="12" fill="#F5F3FF" stroke="#8B5CF6" stroke-width="2"/>
<text x="60" y="44" text-anchor="middle" font-size="9" fill="#6D28D9" font-family="sans-serif" letter-spacing="3">✦ ✦ ✦</text>
<text x="60" y="60" text-anchor="middle" font-size="16" fill="#4C1D95" font-family="Georgia, serif" font-weight="bold" font-style="italic">dream</text>
<text x="60" y="78" text-anchor="middle" font-size="16" fill="#4C1D95" font-family="Georgia, serif" font-weight="bold" font-style="italic">big.</text>
<text x="60" y="96" text-anchor="middle" font-size="7.5" fill="#7C3AED" font-family="sans-serif">then do the work.</text>
</svg>`,
  },
  {
    id: "q-slow-morning",
    type: "svg",
    label: "Slow morning",
    defaultScale: "1.4",
    content: `<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="8" y="14" width="104" height="92" rx="10" fill="#FFFBEB" stroke="#D97706" stroke-width="2"/>
<path d="M30 40 Q60 28 90 40" fill="none" stroke="#FDE68A" stroke-width="2"/>
<circle cx="60" cy="35" r="12" fill="#FDE68A" stroke="#D97706" stroke-width="1.5"/>
<path d="M52 33 Q56 28 60 33 Q64 28 68 33" fill="none" stroke="#D97706" stroke-width="1.5" stroke-linecap="round"/>
<text x="60" y="62" text-anchor="middle" font-size="9" fill="#92400E" font-family="Georgia, serif" font-style="italic">slow mornings</text>
<text x="60" y="76" text-anchor="middle" font-size="9" fill="#78350F" font-family="Georgia, serif" font-style="italic">are sacred</text>
<path d="M28 86 L92 86" stroke="#FCD34D" stroke-width="1.5" stroke-linecap="round"/>
<text x="60" y="97" text-anchor="middle" font-size="7" fill="#B45309" font-family="sans-serif">☕ no rush today</text>
</svg>`,
  },
];

// ─── Emoji stickers ───────────────────────────────────────────────────────────

export const EMOJI_STICKERS: StickerItem[] = [
  // Motivational & positive
  "✨", "⭐", "🌟", "💫", "🔥", "⚡", "🎯", "🏆",
  // Nature
  "🌙", "☀️", "🌈", "🌸", "🌺", "🌿", "🍃", "🌱",
  "🌻", "🌷", "🪷", "🍀", "🌊", "🌅", "🏔️", "🌲",
  // Food & coffee
  "☕", "🫖", "🍵", "🥐", "🥑", "🍓", "🍇", "🫐",
  "🍊", "🍋", "🍰", "🧁", "🫙", "🧃", "🍫", "🍬",
  // Journaling & creativity
  "📖", "📝", "🎨", "🪄", "💡", "🔑", "🗝️", "💎",
  "👑", "🦋", "🕊️", "🐝", "💌", "🖊️", "📚", "🪴",
  // Self-love & emotions
  "❤️", "🫶", "💛", "💚", "💙", "💜", "🤍", "🖤",
  "🥰", "🤗", "🫂", "😌", "🧘", "🛁", "🕯️", "🧸",
  // Reflection & complex emotions
  "🤔", "😶‍🌫️", "🥺", "😮‍💨", "😔", "💭", "🌧️", "⛈️",
  "😤", "😢", "🫠", "😅", "🙃", "😴", "🥴", "🌀",
  // Progress & achievement
  "📈", "🧩", "🪜", "🗺️", "🧭", "⏰", "🌱", "✌️",
].map((e, i) => ({
  id: `emoji-${i}`,
  type: "emoji" as const,
  content: e,
  label: e,
  defaultScale: "1.8",
}));

// ─── Illustrative sticky note shapes ─────────────────────────────────────────

export const STICKY_STICKERS: StickerItem[] = [
  {
    id: "sticky-yellow",
    type: "sticky",
    label: "Yellow sticky",
    defaultScale: "1.6",
    content: `<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0" y="0" width="100" height="100" rx="3" fill="#FEF9C3"/>
<path d="M0 0 L18 0 Q18 18 0 18Z" fill="#FDE68A"/>
<line x1="14" y1="34" x2="86" y2="34" stroke="#D97706" stroke-width="1" opacity="0.25" stroke-dasharray="3 2"/>
<line x1="14" y1="50" x2="82" y2="50" stroke="#D97706" stroke-width="1" opacity="0.25" stroke-dasharray="3 2"/>
<line x1="14" y1="66" x2="84" y2="66" stroke="#D97706" stroke-width="1" opacity="0.25" stroke-dasharray="3 2"/>
<line x1="14" y1="82" x2="78" y2="82" stroke="#D97706" stroke-width="1" opacity="0.25" stroke-dasharray="3 2"/>
</svg>`,
  },
  {
    id: "sticky-green",
    type: "sticky",
    label: "Green sticky",
    defaultScale: "1.6",
    content: `<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0" y="0" width="100" height="100" rx="3" fill="#D1FAE5"/>
<path d="M0 0 L18 0 Q18 18 0 18Z" fill="#A7F3D0"/>
<line x1="14" y1="34" x2="86" y2="34" stroke="#059669" stroke-width="1" opacity="0.2" stroke-dasharray="3 2"/>
<line x1="14" y1="50" x2="82" y2="50" stroke="#059669" stroke-width="1" opacity="0.2" stroke-dasharray="3 2"/>
<line x1="14" y1="66" x2="84" y2="66" stroke="#059669" stroke-width="1" opacity="0.2" stroke-dasharray="3 2"/>
<line x1="14" y1="82" x2="78" y2="82" stroke="#059669" stroke-width="1" opacity="0.2" stroke-dasharray="3 2"/>
</svg>`,
  },
  {
    id: "sticky-lavender",
    type: "sticky",
    label: "Lavender sticky",
    defaultScale: "1.6",
    content: `<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0" y="0" width="100" height="100" rx="3" fill="#EDE9FE"/>
<path d="M0 0 L18 0 Q18 18 0 18Z" fill="#DDD6FE"/>
<line x1="14" y1="34" x2="86" y2="34" stroke="#7C3AED" stroke-width="1" opacity="0.2" stroke-dasharray="3 2"/>
<line x1="14" y1="50" x2="82" y2="50" stroke="#7C3AED" stroke-width="1" opacity="0.2" stroke-dasharray="3 2"/>
<line x1="14" y1="66" x2="84" y2="66" stroke="#7C3AED" stroke-width="1" opacity="0.2" stroke-dasharray="3 2"/>
<line x1="14" y1="82" x2="78" y2="82" stroke="#7C3AED" stroke-width="1" opacity="0.2" stroke-dasharray="3 2"/>
</svg>`,
  },
  {
    id: "sticky-blue",
    type: "sticky",
    label: "Blue sticky",
    defaultScale: "1.6",
    content: `<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0" y="0" width="100" height="100" rx="3" fill="#DBEAFE"/>
<path d="M0 0 L18 0 Q18 18 0 18Z" fill="#BFDBFE"/>
<line x1="14" y1="34" x2="86" y2="34" stroke="#2563EB" stroke-width="1" opacity="0.2" stroke-dasharray="3 2"/>
<line x1="14" y1="50" x2="82" y2="50" stroke="#2563EB" stroke-width="1" opacity="0.2" stroke-dasharray="3 2"/>
<line x1="14" y1="66" x2="84" y2="66" stroke="#2563EB" stroke-width="1" opacity="0.2" stroke-dasharray="3 2"/>
<line x1="14" y1="82" x2="78" y2="82" stroke="#2563EB" stroke-width="1" opacity="0.2" stroke-dasharray="3 2"/>
</svg>`,
  },
  {
    id: "sticky-peach",
    type: "sticky",
    label: "Peach sticky",
    defaultScale: "1.6",
    content: `<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0" y="0" width="100" height="100" rx="3" fill="#FEF3C7"/>
<path d="M0 0 L18 0 Q18 18 0 18Z" fill="#FDE68A"/>
<line x1="14" y1="34" x2="86" y2="34" stroke="#F59E0B" stroke-width="1" opacity="0.25" stroke-dasharray="3 2"/>
<line x1="14" y1="50" x2="82" y2="50" stroke="#F59E0B" stroke-width="1" opacity="0.25" stroke-dasharray="3 2"/>
<line x1="14" y1="66" x2="84" y2="66" stroke="#F59E0B" stroke-width="1" opacity="0.25" stroke-dasharray="3 2"/>
<line x1="14" y1="82" x2="78" y2="82" stroke="#F59E0B" stroke-width="1" opacity="0.25" stroke-dasharray="3 2"/>
</svg>`,
  },
  {
    id: "sticky-sage",
    type: "sticky",
    label: "Sage sticky",
    defaultScale: "1.6",
    content: `<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0" y="0" width="100" height="100" rx="3" fill="#ECFDF5"/>
<path d="M0 0 L18 0 Q18 18 0 18Z" fill="#D1FAE5"/>
<line x1="14" y1="34" x2="86" y2="34" stroke="#10B981" stroke-width="1" opacity="0.2" stroke-dasharray="3 2"/>
<line x1="14" y1="50" x2="82" y2="50" stroke="#10B981" stroke-width="1" opacity="0.2" stroke-dasharray="3 2"/>
<line x1="14" y1="66" x2="84" y2="66" stroke="#10B981" stroke-width="1" opacity="0.2" stroke-dasharray="3 2"/>
<line x1="14" y1="82" x2="78" y2="82" stroke="#10B981" stroke-width="1" opacity="0.2" stroke-dasharray="3 2"/>
</svg>`,
  },
  {
    id: "washi-stripe",
    type: "svg",
    label: "Washi lavender",
    content: `<svg viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0" y="0" width="120" height="40" rx="3" fill="#DDD6FE" opacity="0.75"/>
<line x1="0" y1="8" x2="120" y2="8" stroke="#A78BFA" stroke-width="0.8" stroke-dasharray="5 4"/>
<line x1="0" y1="32" x2="120" y2="32" stroke="#A78BFA" stroke-width="0.8" stroke-dasharray="5 4"/>
</svg>`,
    defaultScale: "1.4",
  },
  {
    id: "washi-floral",
    type: "svg",
    label: "Washi floral",
    content: `<svg viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0" y="0" width="120" height="40" rx="3" fill="#FEF9C3" opacity="0.8"/>
<line x1="0" y1="6" x2="120" y2="6" stroke="#D97706" stroke-width="1"/>
<line x1="0" y1="34" x2="120" y2="34" stroke="#D97706" stroke-width="1"/>
<circle cx="16" cy="20" r="5" fill="#FDE68A" stroke="#D97706" stroke-width="1"/>
<circle cx="36" cy="20" r="4" fill="#FBCFE8" stroke="#EC4899" stroke-width="1"/>
<circle cx="56" cy="20" r="5" fill="#BBF7D0" stroke="#059669" stroke-width="1"/>
<circle cx="76" cy="20" r="4" fill="#FDE68A" stroke="#D97706" stroke-width="1"/>
<circle cx="96" cy="20" r="5" fill="#FBCFE8" stroke="#EC4899" stroke-width="1"/>
<circle cx="112" cy="20" r="4" fill="#BBF7D0" stroke="#059669" stroke-width="1"/>
</svg>`,
    defaultScale: "1.4",
  },
];

// ─── GIF stickers ─────────────────────────────────────────────────────────────

export const GIF_STICKERS: StickerItem[] = [
  // Nature & calm
  { id: "gif-stars",       type: "gif", label: "Stars",        content: "https://media.giphy.com/media/3oKIPwaFWVqhaKheOc/giphy.gif" },
  { id: "gif-sparkle",     type: "gif", label: "Sparkle",      content: "https://media.giphy.com/media/3o6ZsYm5Yu3M8DXFCo/giphy.gif" },
  { id: "gif-flower",      type: "gif", label: "Flower bloom",  content: "https://media.giphy.com/media/xTiTnLmaxrlBHmfHEQ/giphy.gif" },
  { id: "gif-sun",         type: "gif", label: "Sunshine",     content: "https://media.giphy.com/media/3o7abGQa0aRJUurpII/giphy.gif" },
  { id: "gif-rainbow",     type: "gif", label: "Rainbow",      content: "https://media.giphy.com/media/xTiTnxpQ3ghPiB2Hp6/giphy.gif" },
  { id: "gif-leaf",        type: "gif", label: "Leaves",       content: "https://media.giphy.com/media/xT5LMFZDsj0AKUDYTS/giphy.gif" },
  { id: "gif-moon-stars",  type: "gif", label: "Moon & stars", content: "https://media.giphy.com/media/l0Iy9HeWCKGdNf8ly/giphy.gif" },
  // Coffee & cozy
  { id: "gif-coffee",      type: "gif", label: "Coffee steam", content: "https://media.giphy.com/media/l0HlBO7eyXzSZkJri/giphy.gif" },
  { id: "gif-wave",        type: "gif", label: "Ocean wave",   content: "https://media.giphy.com/media/xTiTnu0Hw5YjqoqBji/giphy.gif" },
  // Celebration & energy
  { id: "gif-confetti",    type: "gif", label: "Confetti",     content: "https://media.giphy.com/media/26tOZ42Mg6pbTUPHW/giphy.gif" },
  { id: "gif-twinkle",     type: "gif", label: "Twinkle",      content: "https://media.giphy.com/media/kho9KnLHIRq4g/giphy.gif" },
  { id: "gif-heart",       type: "gif", label: "Heart beat",   content: "https://media.giphy.com/media/l0MYB8Ory7Hqefo9a/giphy.gif" },
  // Self-care & calm
  { id: "gif-butterfly2",  type: "gif", label: "Butterfly",    content: "https://media.giphy.com/media/l0HlHFRbmaZtBRhXG/giphy.gif" },
  { id: "gif-cat-cozy",    type: "gif", label: "Cozy cat",     content: "https://media.giphy.com/media/JIX9t2j0ZTN9S/giphy.gif" },
  { id: "gif-rain",        type: "gif", label: "Rainy window",  content: "https://media.giphy.com/media/3oKIPjHCmuXqdVvak8/giphy.gif" },
  // Emotional expression
  { id: "gif-hug",         type: "gif", label: "Warm hug",     content: "https://media.giphy.com/media/l0MYt5jPR6QX5pnqM/giphy.gif" },
  { id: "gif-dance",       type: "gif", label: "Happy dance",  content: "https://media.giphy.com/media/5GoVLqeAOo6PK/giphy.gif" },
  { id: "gif-breathe",     type: "gif", label: "Breathe",      content: "https://media.giphy.com/media/3oKIPa2TdahY8LAAxy/giphy.gif" },
  { id: "gif-sunrise",     type: "gif", label: "Sunrise",      content: "https://media.giphy.com/media/l0HlFZ3pQnuVOHzwc/giphy.gif" },
  { id: "gif-meditation",  type: "gif", label: "Meditate",     content: "https://media.giphy.com/media/3o7ZetIsjtbkgNE1I4/giphy.gif" },
];

// ─── All sticker categories ───────────────────────────────────────────────────

export const ALL_STICKERS = {
  stickers: SVG_STICKERS,
  quotes:   QUOTE_STICKERS,
  emojis:   EMOJI_STICKERS,
  stickies: STICKY_STICKERS,
  gifs:     GIF_STICKERS,
};

export type StickerCategory = keyof typeof ALL_STICKERS;
